<ng-template #feedbackModal let-modal>
  <div class="feedback-modal-width">
    <div class="modal-header d-flex">
      <span class="user-title-font">Provide Feedback</span>
      <div class="justify-content-end default-pointer" (click)="modal.close('Cancel')" title="Close" aria-label="Close" id="closeModalBtn">
        <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 384 512">
          <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
          <path
            fill="var(--grey-text-color)"
            d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
          />
        </svg>
      </div>
    </div>
    <div class="modal-body">
      <div class="mb-2 default-font">
        Thanks for providing feedback! Your input is valuable and will help us optimize content and improvide the overall experience of Termhub.
      </div>
      <div class="row mb-2">
        <div class="col-md-5 mb-2">
          <app-select
            [id]="'selectFeedbackTypeBtn'"
            [label]="'Feedback Type'"
            [selected]="selectedFeedbackType"
            [placeholder]="'Specify the feedback type'"
            [options]="feedbackTypes"
            [tab]="1"
            [focused]="true"
            (selectedOption)="selectFeedbackType($event)"
          ></app-select>
        </div>
        <div class="col-md-7 mb-2 mt-2">
          <app-input
            [label]="'Feedback Subject'"
            [for]="'subjectFC'"
            [placeholder]="'Enter the feedback subject'"
            type="text"
            [maxlength]="50"
            [control]="subjectFC"
            [tab]="2"
            (focusout)="setFeedbackSubject()"
          ></app-input>
        </div>
      </div>
      <div class="mb-3">
        <div class="mb-2"><span class="input-text-font">Description</span></div>
        <textarea
          [formControl]="descriptionFC"
          class="form-control input-font description-input"
          placeholder="Please leave a detailed description"
          tabindex="3"
          (focusout)="setFeedbackDescription()"
          id="userFeedbackDescription"
        ></textarea>
      </div>
      <div class="mb-3">
        <div class="mb-2"><span class="input-text-font">Please rate your overall Termhub experience:</span></div>
        <ngb-rating [(rate)]="feedbackForm.rating" [max]="5" tabindex="4" (rateChange)="checkFeedbackInput()" id="userFeedbackRating">
          <ng-template let-fill="fill" let-index="index">
            <span class="star" [ngClass]="'color'" title="{{ index + 1 + ' Stars' }}" [class.filled]="fill === 100">&#9733;</span>
          </ng-template>
        </ngb-rating>
      </div>
      <div>
        <app-option
          [id]="'feedbackRadio'"
          [label]="'May we follow-up with you regarding your feedback?'"
          [type]="'radio'"
          [control]="feedbackFollowupFC"
          [name]="'feedbackRadio'"
          class="radio-option"
          tabindex="5"
          [options]="[
            { label: 'Yes', value: true, disabled: false, selected: false },
            { label: 'No', value: false, disabled: false, selected: false },
          ]"
        ></app-option>
      </div>
    </div>
    <div class="modal-footer">
      <app-button
        title="Cancel"
        class="pr-1"
        tabindex="7"
        for="cancelBtn"
        [small]="true"
        btnType="primary-outline"
        type="submit"
        (click)="modal.close('Cancel')"
        >Cancel</app-button
      >
      <app-button
        title="Send Feedback"
        for="feedbackBtn"
        tabindex="6"
        [small]="true"
        btnType="primary-solid"
        type="submit"
        (click)="modal.close('Send')"
        >Submit</app-button
      >
    </div>
  </div>
</ng-template>
